import { CONFIG, FEATURE_TOGGLES } from '../../utils/constants';
export default {
  getters: {
    [FEATURE_TOGGLES.UNIT_FINANCIAL_POSITION]: (state, getters) =>
      getters[CONFIG.GET_FEATURE_TOGGLES][
        FEATURE_TOGGLES.UNIT_FINANCIAL_POSITION
      ],
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/featureToggles.js